const Id = (cell) => {
    return cell.value ? cell.value : '';
};
const CategoryCode = (cell)=>{
    return cell.value? cell.value:'';
}
const CategoryName = (cell) => {
    return cell.value ? cell.value : '';
};
const CategoryDescription = (cell) => {
    return cell.value ? cell.value : '';
};



export {
    Id,CategoryName,CategoryDescription,CategoryCode
};